import { requestAPI } from './requestApi';

export const getClaimableDates = (eventId:string) => requestAPI(`/events/${encodeURI(eventId)}/isShirtClaimableDates/`);

export const getShirtForUser = (eventId: string) => requestAPI(`/events/${encodeURI(eventId)}/shirts/`);

export function setShirtForUser(eventId: string, size: string) {
	return requestAPI(`/events/${encodeURI(eventId)}/shirts/`, 'POST', { 'Content-type': 'application/json' }, JSON.stringify({ shirtSize: size }));
}
